import React from 'react';
import { Route, Routes, Navigate } from 'react-router';
import {
  Loader,
  ServiceWorkerProvider,
  Suspense,
  LayoutBleed,
  Page,
  useApi,
} from '@axiom/ui';

import DefaultLayout from './layouts/default';
import { NotFoundPage } from './pages/NotFoundPage';
import { ConvertUserIdsPage } from './pages/ConvertUserIdsPage';
import { OpportunityDetailPage } from './pages/OpportunityDetailPage';
import { TalentDetailPage } from './pages/TalentDetailPage';
import { BenchPage } from './pages/BenchPage';
import { TalentPage } from './pages/TalentPage';
import { OpportunitiesPage } from './pages/OpportunitiesPage';
import { WorkspacePage } from './pages/WorkspacePage';
import { CandidateBios } from './components/CandidateBios/CandidateBios';
import { QueryHandler } from './components/QueryHandler/QueryHandler';
import { UserApi } from './api/user-api';
import { SparkPage } from './spark/pages/SparkPage';

export const Router = () => {
  const [{ data: user }] = useApi(UserApi.readSessionUser());

  return (
    <>
      <QueryHandler />
      <ServiceWorkerProvider />
      <Routes>
        <Route path="" element={<Navigate to="/workspace" />} />
        <Route path="bench">
          <Route index path="*" element={<BenchPage name="BENCH_PAGE" />} />
        </Route>
        <Route path="workspace">
          <Route path="" element={<Navigate to="opportunities" replace />} />
          <Route
            path="bench-reminders"
            element={
              <WorkspacePage name="WorkspacePage" key="bench-reminders" />
            }
          />
          <Route
            path="incomplete-bios"
            element={
              <WorkspacePage name="WorkspacePage" key="incomplete-bios" />
            }
          />
          <Route
            path="feedback"
            element={<WorkspacePage name="WorkspacePage" key="feedback" />}
          />
          <Route
            path="talent-management"
            element={
              <WorkspacePage name="WorkspacePage" key="talent-management" />
            }
          />
          <Route
            path="talent-feedback"
            element={
              <WorkspacePage name="WorkspacePage" key="talent-feedback" />
            }
          />
          <Route
            path="interviews"
            element={<WorkspacePage name="WorkspacePage" key="interviews" />}
          />
          <Route path="opportunities">
            <Route
              index
              path="*"
              element={
                <WorkspacePage name="WorkspacePage" key="opportunities" />
              }
            />
          </Route>
          <Route
            path="*"
            element={<Navigate to="../opportunities" replace />}
          />
        </Route>
        <Route
          path="opportunities"
          element={<OpportunitiesPage name="OpportunitiesPage" />}
        />
        <Route path="opportunity-detail/:id">
          <Route
            index
            path="*"
            element={<OpportunityDetailPage name="OpportunityDetailPage" />}
          />
          <Route
            path="submission/:viewId/:tab"
            element={<OpportunityDetailPage />}
          />
          <Route
            path="submission/:viewId"
            element={<OpportunityDetailPage />}
          />
        </Route>
        <Route path="talent">
          <Route index path="*" element={<TalentPage name="TalentPage" />} />
        </Route>

        <Route
          path="talent/:candidateId/bio/anonymous?"
          element={
            <Page>
              <DefaultLayout simple>
                <Suspense fallback={<Loader type="bars" />}>
                  <LayoutBleed>
                    <CandidateBios name="CandidateBios" user={user} />
                  </LayoutBleed>
                </Suspense>
              </DefaultLayout>
            </Page>
          }
        />
        <Route
          path="talent/:candidateId/download/bio/anonymous?"
          element={
            <LayoutBleed>
              <Suspense fallback={<Loader type="bars" />}>
                <CandidateBios name="CandidateBios" user={user} />
              </Suspense>
            </LayoutBleed>
          }
        />

        <Route path="talent-detail/:id">
          <Route
            index
            path="*"
            element={<TalentDetailPage name="TalentDetailPage" />}
          />
        </Route>
        <Route
          path="convert-user-ids"
          element={<ConvertUserIdsPage name="ConvertUserIdsPage" />}
        />

        {/*
          Nothing reaches this today - the list read has its own boundary in `LeftColumn`. Kept
          because the next one above is `index.js`'s, which has no `fallback` and so blanks the app.
        */}
        <Route path="spark" element={<SparkPage name="SparkPage" />} />

        <Route path="404" element={<NotFoundPage name="NotFoundPage" />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </>
  );
};
